/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Export_Complete_TextInputs */

const en_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption file published successfully to Ateliere Connect.`)
};

const fr_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de sous-titres publié avec succès sur Ateliere Connect.`)
};

const de_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Untertiteldatei wurde erfolgreich in Ateliere Connect veröffentlicht.`)
};

const it_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File didascalia pubblicato correttamente su Ateliere Connect.`)
};

const ru_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл с субтитрами успешно опубликован в Ateliere Connect.`)
};

const es_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de subtítulo publicado exitosamente en Ateliere Connect.`)
};

const zh_cn2_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕文件已成功发布到 Ateliere Connect。`)
};

const ja_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプション ファイルが Ateliere Connect に正常に公開されました。`)
};

const hi_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन फाइल एटेलियर कनेक्ट पर सफलतापूर्वक प्रकाशित हो गई है।`)
};

const pt_pt2_ateliere_connect_export_complete_text = /** @type {(inputs: Ateliere_Connect_Export_Complete_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda publicada com sucesso no Ateliere Connect.`)
};

/**
* | output |
* | --- |
* | "Caption file published successfully to Ateliere Connect." |
*
* @param {Ateliere_Connect_Export_Complete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_export_complete_text = /** @type {((inputs?: Ateliere_Connect_Export_Complete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Export_Complete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_export_complete_text(inputs)
	if (locale === "de") return de_ateliere_connect_export_complete_text(inputs)
	if (locale === "it") return it_ateliere_connect_export_complete_text(inputs)
	if (locale === "ru") return ru_ateliere_connect_export_complete_text(inputs)
	if (locale === "es") return es_ateliere_connect_export_complete_text(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_export_complete_text(inputs)
	if (locale === "ja") return ja_ateliere_connect_export_complete_text(inputs)
	if (locale === "hi") return hi_ateliere_connect_export_complete_text(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_export_complete_text(inputs)
	return en_ateliere_connect_export_complete_text(inputs)
});